import {PageTemplate} from "../../shared/layout/PageTemplate";
import {IrrelevanceContent} from "./components/IrrelevanceContent";

export function Irrelevance() {
    return <PageTemplate pageName="Irrelevance" title="Enum" content={<IrrelevanceContent/>}/>
}
